// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"CountriesList_contentComponent__15zsL"};